<template>
  <div class="body">
    <div v-for="definition in rows" :key="`row-${definition.id}`" class="flex">
      <ListLine
        :id="definition.id"
        :data="definition.data"
        :checked="definition.checked"
        :loading="definition.loading"
        :propertyTeams="definition.propertyTeams || []"
        :hasUnsyncedData="definition.hasUnsyncedData || false"
        :onAttribute="onAttribute"
        :onPlanify="onPlanify(definition.id)"
        :onResetPlanification="onResetPlanification(definition.id)"
        :onCheck="onCheck"
      />
      <ListDropdown
        :id="definition.id"
        :onDelete="onDelete(definition.id)"
        :onPostpone="onPostpone(definition.id)"
        :onClose="closeDropdown(definition.id)"
        :open="definition.dropdown.open"
        :actions="definition.dropdown.actions"
      />
    </div>
  </div>
</template>

<script>
import ListLine from './ListLine.vue'
import ListDropdown from './Dropdown.vue'

export default {
  name: 'ListBody',
  components: {
    ListLine,
    ListDropdown
  },
  props: {
    rows: {
      type: Array,
      default: () => []
    },
    onAttribute: {
      type: Function,
      default: () => () => () => null
    },
    onPlanify: {
      type: Function,
      default: () => () => () => null
    },
    onResetPlanification: {
      type: Function,
      default: () => () => () => null
    },
    onCheck: {
      type: Function,
      default: () => () => () => null
    },
    onDelete: {
      type: Function,
      default: () => () => () => null
    },
    onPostpone: {
      type: Function,
      default: () => () => () => null
    },
    toggleDropdown: {
      type: Function,
      default: () => () => () => null
    },
    closeDropdown: {
      type: Function,
      default: () => () => () => null
    }
  }
}
</script>
